export const passthrough = value => value;